import { styled } from '@linaria/react';

import { fonts, semantic } from '../../theme/tokens';

export const ErrorText = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.danger};
`;
